import { defineMessages } from 'react-intl';

export const CoachmarksSearch = defineMessages({
  stepOneParagraphOne: {
    id: 'coachmarks.Search.Step.One.P1',
    defaultMessage:
      '<p>Before you start exploring schools, a few tips:<br />Use this menu bar to move through the application at your own pace. Just be sure to submit your application (Apply) before the deadline!</p>',
    description: 'Coachmarks search step one P1',
  },
  stepOneParagraphTwo: {
    id: 'coachmarks.Search.Step.One.P2',
    defaultMessage:
      'Return to Overview at any time to view your checklist and track your progress. Later steps are also available, but focus on Search for now!',
    description: 'Coachmarks search step one P2',
  },
  stepTwoParagraphOne: {
    id: 'coachmarks.Search.Step.Two.P1',
    defaultMessage:
      '<p>Before you start exploring schools, a few tips!</p>',
    description: 'Coachmarks search step two P1',
  },
  stepTwoParagraphTwo: {
    id: 'coachmarks.Search.Step.Two.P2',
    defaultMessage:
      '<p>Students actually apply to programs at schools. Each school card also lists programs at that school.</p>',
    description: 'Coachmarks search step two P2',
  },
  stepThreeParagraphOne: {
    id: 'coachmarks.Search.Step.Three.P1',
    defaultMessage:
      '<p>Think of a program (like this one) as a doorway to get into the school. Tap or click on programs to learn about them.</p>',
    description: 'Coachmarks search step three P1',
  },
  stepThreeParagraphTwo: {
    id: 'coachmarks.Search.Step.Three.P2',
    defaultMessage:
      '<p>You can apply to multiple programs at a school, if you’re interested in more than one. Some schools have programs that focus on certain interests or areas of study, and some schools have programs that reflect the whole school’s offerings.</p>',
    description: 'Coachmarks search step three P2',
  },
  stepFourParagraphOne: {
    id: 'coachmarks.Search.Step.Four.ParagraphOne',
    defaultMessage: '<p>How to decide? There are a lot of programs, and a lot of information about each.</p>',
    description: 'Coachmarks search step four paragraph one',
  },
  stepFourParagraphTwo: {
    id: 'coachmarks.Search.Step.Four.ParagraphTwo',
    defaultMessage:
      '<p>Many families consider the daily commute and the school’s location to be important factors. Use the map to see a school’s location and the distance from your child’s home.</p>',
    description: 'Coachmarks search step four paragraph two',
  },
  stepFiveParagraphOne: {
    id: 'coachmarks.Search.Step.Five.ParagraphOne',
    defaultMessage:
      '<p>How to decide? Use the filters below the search bar to see only schools that meet certain criteria. From More Filters, select the Eligible filter to only see schools you can list on your application!</p>',
    description: 'Coachmarks search step five paragraph one',
  },
  stepFiveParagraphTwo: {
    id: 'coachmarks.Search.Step.Five.ParagraphTwo',
    defaultMessage:
      '<p>Find information on criteria like academic performance, sports, and activities by selecting a school or program.</p>',
    description: 'Coachmarks search step five paragraph two',
  },
  stepSix: {
    id: 'coachmarks.Search.Step.Six',
    defaultMessage:
      '<p>When you find a program you like, click the star to add it to your favorites.</p><p>You can view your list of your favorite programs on the apply page.</p>',
    description: 'Coachmarks search step six',
  },
  stepSeven: {
    id: 'coachmarks.Search.Step.Seven',
    defaultMessage:
      'Want to better understand your child’s chances of getting an offer to each program? Hover or tap these icons to learn about the program’s demand and find out your child’s priority group. These icons will not display if your child is not eligible for the program, or if the program is their guaranteed program. Click or tap on the program for more details.',
    description: 'Coachmarks search step seven',
  },
  stepEight: {
    id: 'coachmarks.Search.Step.Eight',
    defaultMessage:
      'You’re ready to start exploring programs!',
    description: 'Coachmarks search step eight',
  },
});

export const CoachmarksSummerRisingSearch = defineMessages({
  stepOneParagraphOneForAfiliated: {
    id: 'coachmarks.SR.Search.Step.One.Affiliated',
    defaultMessage:
      '<p>Welcome to the Summer Rising application portal. This is your affiliated Summer Rising location. This is where your current school is located for the summer.</p>',
    description: 'Coachmarks SR search step one for students with affiliated school',
  },
  stepOneParagraphOneForNonAfiliated: {
    id: 'coachmarks.SR.Search.Step.One.NonAffiliated',
    defaultMessage:
      '<p>Welcome to the Summer Rising application portal. This is a Summer Rising location.</p>',
    description: 'Coachmarks SR search step one for students without affiliated school',
  },
  stepThreeParagraphOne: {
    id: 'coachmarks.SR.Search.Step.Three.P1',
    defaultMessage:
      '<p>This is a Summer Rising Community Based Organization program. There may be multiple programs at a location.</p>',
    description: 'Coachmarks search step three P1',
  },
  stepFiveParagraphOne: {
    id: 'coachmarks.SR.Search.Step.Five.ParagraphOne',
    defaultMessage:
      '<p>Use the search and filters to find more Summer Rising locations.</p>',
    description: 'Coachmarks search step five paragraph one',
  },
  stepSix: {
    id: 'coachmarks.SR.Search.Step.Six',
    defaultMessage:
      '<p>When you find a program you like, click the star to add it to your favorites.</p><p>You can view your list of your favorite programs on the apply page.</p>',
    description: 'Coachmarks search step six',
  },
  stepEight: {
    id: 'coachmarks.SR.Search.Step.Eight',
    defaultMessage:
      'When you are done exploring programs, click Apply to go to your application.',
    description: 'Coachmarks search step eight',
  },
});

export const CoachmarksSaved = defineMessages({
  stepOne: {
    id: 'coachmarks.Saved.Step.One',
    defaultMessage:
      '<p>Your saved programs are listed on this page. Use this page to consider the ones you’re interested in applying to in more detail.</p><p>You can search and filter your Saved programs, just like on the Search page.</p>',
    description: 'Coachmarks saved step one',
  },
  stepTwoParagraphOne: {
    id: 'coachmarks.Saved.Step.Two.ParagraphOne',
    defaultMessage:
      '<p>You can also view school and program details, like on the Search page. If you decide you’re no longer interested in a program, you can unsave it by tapping or clicking on the star.</p>',
    description: 'Coachmarks saved step two paragraph one',
  },
  stepTwoParagraphTwo: {
    id: 'coachmarks.Saved.Step.Two.ParagraphTwo',
    defaultMessage:
      '<p>Unlike on Search, if you save multiple programs from a single school, each program appears on a separate school card.</p>',
    description: 'Coachmarks saved step two paragraph two',
  },
  stepThree: {
    id: 'coachmarks.Saved.Step.Three',
    defaultMessage:
      'You can choose to order saved programs with the most recently saved ones at the top or by their distance from your child’s home.',
    description: 'Coachmarks saved step three',
  },
  stepFourParagraphOne: {
    id: 'coachmarks.Saved.Step.Four.ParagraphOne',
    defaultMessage:
      '<p>Try saving at least 25 programs! If you’ve saved fewer, you’ll see a reminder above your list.</p>',
    description: 'Coachmarks saved step four paragraph one',
  },
  stepFourParagraphTwo: {
    id: 'coachmarks.Saved.Step.Four.ParagraphTwo',
    defaultMessage:
      '<p>You can return to Search to find more programs to save, and then back to Saved to view just the ones you’re considering.</p>',
    description: 'Coachmarks saved step four paragraph two',
  },
});

export const CoachmarksSchedule = defineMessages({
  stepOneParagraphOne: {
    id: 'coachmarks.Schedule.Step.One.ParagraphOne',
    defaultMessage:
      '<p>Programs you’ve saved that require an assessment for admission (for example, an audition, test, interview, etc.) are listed on this page.</p>',
    description: 'Coachmarks schedule step one paragraph one',
  },
  stepOneParagraphTwo: {
    id: 'coachmarks.Schedule.Step.One.ParagraphTwo',
    defaultMessage:
      '<p>While you can submit your application before you’ve done a program’s assessment, you must at least schedule it or express your interest before you can add the program to your application. You’ll do that here.</p>',
    description: 'Coachmarks schedule step one paragraph two',
  },
  stepTwo: {
    id: 'coachmarks.Schedule.Step.Two',
    defaultMessage:
      '<p>If you have yet to schedule a program’s assessment or express your interest, you can do so here.</p><p>Tap or click this button and follow the steps to complete the request.</p><p>The school may contact you to schedule (or reschedule if necessary) a time for your assessment.</p>',
    description: 'Coachmarks schedule step two',
  },
  stepThreeParagraphOne: {
    id: 'coachmarks.Schedule.Step.Three.ParagraphOne',
    defaultMessage:
      '<p>Check your Scheduled list to review any programs you’ve scheduled assessments for, or expressed interest in.</p>',
    description: 'Coachmarks schedule step three paragraph one',
  },
  stepThreeParagraphTwo: {
    id: 'coachmarks.Schedule.Step.Three.ParagraphTwo',
    defaultMessage:
      '<p>You can return here at any time to find dates, time, and locations for assessments you scheduled online. If you express interest and the school then contacts you to schedule, be sure to keep track of that appointment yourself!</p>',
    description: 'Coachmarks schedule step three paragraph two',
  },
  stepFour: {
    id: 'coachmarks.Schedule.Step.Four',
    defaultMessage:
      'Remember, just because a program you’ve saved is shown on this page does not mean you have to schedule an assessment for it — only if you definitely want to apply to it!',
    description: 'Coachmarks schedule step four',
  },
});

export const CoachmarksApply = defineMessages({
  stepOneParagraphOne: {
    id: 'coachmarks.Apply.Step.One.ParagraphOne',
    defaultMessage: '<p>On this page, you’ll build your application — and eventually submit it!</p>',
    description: 'Coachmarks apply step one paragraph one',
  },
  stepOneParagraphOneSR: {
    id: 'coachmarks.Apply.SR.Step.One.ParagraphOne',
    defaultMessage: '<p>We automatically placed your affiliated programs in the favorites section if you have one.</p>',
    description: 'Coachmarks apply step one paragraph one for SR',
  },
  stepOneParagraphTwo: {
    id: 'coachmarks.Apply.Step.One.ParagraphTwo',
    defaultMessage:
      '<p>If you’ve added programs to your favorites, you’ll find them here and can add them to your application. You can always remove programs and re-submit your application (until the deadline), so feel free to try adding some.</p>',
    description: 'Coachmarks apply step one paragraph two',
  },
  stepOneParagraphThree: {
    id: 'coachmarks.Apply.Step.One.ParagraphThree',
    defaultMessage:
      '<p>You may not be able to add some programs if you’re not eligible, or if you need to schedule an assessment first. Find that information next to each program.</p>',
    description: 'Coachmarks apply step one paragraphTh three',
  },
  stepTwoParagraphOne: {
    id: 'coachmarks.Apply.Step.Two.ParagraphOne',
    defaultMessage:
      '<p>View “Your Application” to see the programs you’ve added to your application, or to search for and add any program directly.</p>',
    description: 'Coachmarks apply step two paragraph One',
  },
  stepTwoParagraphTwo: {
    id: 'coachmarks.Apply.Step.Two.ParagraphTwo',
    defaultMessage:
      '<p>Drag and drop programs to reorder them. Click on programs in the list to view details in order to make final decisions about how to order your list.</p>',
    description: 'Coachmarks apply step two paragraph Two',
  },
  stepTwoParagraphThree: {
    id: 'coachmarks.Apply.Step.Two.ParagraphThree',
    defaultMessage: '<p>It’s important to list programs in your true order of preference. Order matters!</p>',
    description: 'Coachmarks apply step two paragraph Three',
  },
  stepThree: {
    id: 'coachmarks.Apply.Step.Three',
    defaultMessage:
      'It’s important to apply to {maxPrograms} programs! Once you’ve filled up your list, you can prepare to submit it (during the application period) by clicking the button at the bottom of your application.',
    description: 'Coachmarks apply step three',
  },
});
